/**
 * This hook delivers information about:
 * a) Pool (actually Ticker)
 * b) Coin
 * Than it merges it into one payload
 */
import { useState, useEffect } from 'react';
import { ICoinWithMarket } from '@kattana-io/common';
import { KattanaAPI } from '../../../store/createStore';

const REFRESH_TIME = 30000;

const useCexPoolInfo = (slug: string) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<ICoinWithMarket | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const controller = new AbortController();

      KattanaAPI.coin(slug, true, true, controller)
        .then((data: any) => {
          setData(data);
          setLoading(false);
        })
        .catch((err: any) => {
          console.warn(err);
          setData(null);
          setLoading(false);
        });

      return () => {
        controller.abort();
      };
    }, REFRESH_TIME);

    return () => clearInterval(interval);
  }, [slug]);

  useEffect(() => {
    setLoading(true);
    setData(null);

    const controller = new AbortController();

    KattanaAPI.coin(slug, true, true, controller)
      .then((data: any) => {
        setData(data);
        setLoading(false);
      })
      .catch((err: any) => {
        console.warn(err);
        if (!controller.signal.aborted) {
          setData(null);
          setLoading(false);
        }
      });

    return () => {
      controller.abort();
    };
  }, [slug]);

  return {
    loading,
    data: data,
  };
};

export default useCexPoolInfo;
